import LogoImage from "../../assets/images/png/omniActiveLogo.png";
import CountDownImage from "../../assets/images/png/countDownUpdated.png";
import FemaleAthlete from "../../assets/images/jpeg/appleHealthImg.jpg";
import MailChimpForm from "./mailChimp";
import SocialMediaIcons from "./socialMediaIcons";

import "./index.scss";

const ComingSoon = () => {
  return (
    <div className="coming-soon">
      <div className="top-coming-soon">
        <img className="company-logo" src={LogoImage} alt="logo image" />
      </div>
      <div className="middle-coming-soon">
        <div className="left-section">
          <div className="launch-date">
            <img className="date-img" src={CountDownImage} alt="" />
          </div>
          <div className="text-subscribe">
            <div className="text">
              Join the <br />
              Movement.
            </div>
            <div className="subscribe-content">
              <MailChimpForm />
            </div>
          </div>
        </div>
        <div className="right-section">
          <img className="fitness-img" src={FemaleAthlete} alt="" />
        </div>
      </div>
      <div className="bottom-coming-soon">
        <SocialMediaIcons />
      </div>
    </div>
  );
};

export default ComingSoon;
